import React, { useEffect } from "react";
import { MdCheckCircle } from "react-icons/md";
import { useDispatch } from "react-redux";
import userStorage from "store/UserStorage";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { colors } from "theme/Theme";
import { setReload } from "../cartSlice";

interface OrderSuccessProps {}

const OrderSuccess: React.FC<OrderSuccessProps> = ({}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(setReload(true));
    userStorage.resetCart();
    dispatch(setReload(false));
  }, []);

  return (
    <OrderSuccessContainer>
      <MdCheckCircle />
      <h3>Поръчката е направена успешно!</h3>
    </OrderSuccessContainer>
  );
};

const OrderSuccessContainer = styled.div`
  margin-top: 10px;
  width: 80vw;
  margin: 0 auto;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;

  svg {
    width: 25vw;
    height: 25vw;
    color: ${colors.light_blue};
  }

  h3 {
    color: black;
    text-align: center;
  }

  @media only screen and (${device.tablet}) {
    svg {
      width: 20vw;
      height: 20vw;
    }
  }

  @media only screen and (${device.laptop}) {
    svg {
      width: 15vw;
      height: 15vw;
    }
  }

  @media only screen and (${device.laptopL}) {
    svg {
      width: 10vw;
      height: 10vw;
    }
  }
`;

export default OrderSuccess;
